import { createMemo, createSignal, Show } from "solid-js";
import { suspendUser, reactivateUser } from "~/lib";

export const SuspendButton = ( props: any ) => {
	const [running, setRunning] = createSignal<boolean>( false );
	const [error, setError] = createSignal<string | null>( null );

	const isSuspended = createMemo( () => props.status == "suspended" );

	const toggle = async () => {
		const confirmMessage = isSuspended()
			? "Are you sure you want to reactivate this user? This will reactivate any subscriptions that were suspended with them."
			: "Are you sure you want to suspend this user? This will also suspend any of their active subscriptions.";

		if ( !confirm( confirmMessage ) ) {
			return;
		}

		setRunning( true );
		setError( null );

		try {
			const r = await ( isSuspended() ? reactivateUser( props.userId ) : suspendUser( props.userId ) );

			if ( r?.success ) {
				props.onChange?.();
			} else {
				setError( r?.error ?? ( isSuspended() ? "Reactivation failed. Please try again." : "Suspension failed. Please try again." ) );
			}
		} catch ( err ) {
			console.error( "Error toggling suspension", err );
			setError( isSuspended() ? "Reactivation failed. Please try again." : "Suspension failed. Please try again." );
		} finally {
			setRunning( false );
		}
	}

	return (
		<div class="flex flex-col items-end gap-1">
			<button onClick={toggle}
				disabled={running()}
				type="button"
				class="rias flex items-center px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline-2 focus-visible:outline-offset-2 disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed"
				classList={{
					"bg-red-600 hover:bg-red-500 focus-visible:outline-red-600": !isSuspended(),
					"bg-primary hover:opacity-90 focus-visible:outline-primary": isSuspended(),
				}}>
				{isSuspended() ? "Reactivate User" : "Suspend User"}
				<Show when={running()}>
					<svg class="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
						<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
						<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
					</svg>
				</Show>
			</button>
			<Show when={error()}>
				<p class="text-xs text-red-600 max-w-50 text-right">{error()}</p>
			</Show>
		</div>
	);
}
